import { render, staticRenderFns } from "./BaseNotifications.vue?vue&type=template&id=472a6bb8&"
import script from "./BaseNotifications.vue?vue&type=script&lang=js&"
export * from "./BaseNotifications.vue?vue&type=script&lang=js&"
import style0 from "./BaseNotifications.vue?vue&type=style&index=0&id=472a6bb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports